import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface attendancesetting {
  Enablecheckin?: any;
}
const initialState: attendancesetting = {
  Enablecheckin: false,
};

const attendancesettingSlice = createSlice({
  name: "attendancesettinginfo",

  initialState,
  reducers: {
    setEnablecheckin: (
      state: attendancesetting,
      action: PayloadAction<attendancesetting>
    ) => {
      const payload = action.payload;
      state.Enablecheckin = payload;
    },
  },
});

export const { setEnablecheckin } = attendancesettingSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default attendancesettingSlice.reducer;
